export const availableGroups = [
  "binoculars" as const,
  "telescopes" as const,
  "riflescopes" as const,
  "premium-gear" as const,
  "thermal-vision" as const,
  "ax-visio-focus" as const,
];
